import { tns } from 'tiny-slider/src/tiny-slider';

export default {

  init() {

    let challengeGalleryList = [].slice.call(document.querySelectorAll('.challenges-carousel'));

    challengeGalleryList.map(function(challengeGallery) {
      return tns({
          container: challengeGallery,
          items: 1,
          loop: false,
          controls: false,
          navPosition: 'bottom',
          controlsContainer: false,
          slideBy: 'page',
          mouseDrag: true,
          gutter: 16,
          nav: true,
          disable: false,
          responsive: {
            600: {
              items: 2,
            },
            990: {
              disable: true,
            },
          },
      });
    });

  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },

};



// WEBPACK FOOTER //
// ./scripts/routes/solution.js